import {PERIODIC_DEPOSIT_FREQUENCY_TO_DV_MAPPING} from '@/constants/engine';
import {DomainValueReference} from '@/model/types';

export const mapPeriodicDepositFrequencyToDomainValue = (depositFrequency?: string): DomainValueReference | null => {
  if (!depositFrequency || !(depositFrequency in PERIODIC_DEPOSIT_FREQUENCY_TO_DV_MAPPING)) return null;

  return {
    $ref: PERIODIC_DEPOSIT_FREQUENCY_TO_DV_MAPPING[
      depositFrequency as keyof typeof PERIODIC_DEPOSIT_FREQUENCY_TO_DV_MAPPING
    ],
  };
};
